
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","baseProfile":"tiny","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 80 80","overflow":"visible"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40 68.333c-15.623 0-28.334-12.71-28.334-28.334 0-15.623 12.711-28.333 28.334-28.333a5 5 0 110 10c-10.109 0-18.334 8.225-18.334 18.334S29.892 58.332 40 58.332c10.108 0 18.333-8.225 18.333-18.334a5 5 0 1110 0c0 15.624-12.71 28.334-28.333 28.334z"}})])
          )
        }
      }
    